import { titleize } from 'underscore.string';
import { unescapeSpecialChars } from 'helpers/helper_functions';

export function getCustomerName(user = {}) {
  let name = '';
  if (user?._type === 'Shipper') {
    name = user?.company_name;
  } else if (user?._type === 'Carrier') {
    name = user?.name;
  } else if (user?._type === 'Consignee') {
    name = user?.company_name;
  } else if (user?._type === 'Driver') {
    name = `${user?.first_name} ${user?.last_name}`;
  }

  return unescapeSpecialChars(`${titleize(name).trim()}`);
}
